module.exports = __webpack_public_path__ + "img/btn_google_light_disabled_ios.08845100.svg";